<template>
	<div>
		<el-tabs v-model="tabName">
			<el-tab-pane label="តំបន់ដឹកជញ្ជូនទាំងអស់" name="first"></el-tab-pane>
			<el-tab-pane label="បង្កើតតំបន់ថ្មី" name="second"></el-tab-pane>
			<el-tab-pane label="ចាត់អ្នកទៅទទួលឥវ៉ាន់" name="third"></el-tab-pane>
			<el-tab-pane label="ចាត់តាំងអ្នកដឹកជញ្ជូន" name="forth"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first'">
			<md-table>
				<md-table-row>
					<md-table-head>តំបន់</md-table-head>
					<md-table-head>ទីតាំង</md-table-head>
					<md-table-head><span class="green">អ្នកទៅទទួលឥវ៉ាន់</span></md-table-head>
					<md-table-head><span class="late">អ្នកដឹកជញ្ជូន</span></md-table-head>
				</md-table-row>
				<template v-for="(zone, index_zone) in zoneList">
					<md-table-row v-for="(location, index_location) in zone.location_list">
						<md-table-cell><b v-if="index_location == 0">
								<span class="green">{{zone.name}}</span>
								<router-link :to="'/zones/edit/' + zone.id">
									<span style="cursor: pointer; margin-left: 8px">
										<md-icon class="md-primary">edit</md-icon>
										<md-tooltip md-direction="top">កែប្រែ</md-tooltip>
									</span>
								</router-link>

							</b></md-table-cell>
						<md-table-cell><span>【{{location.name}}】</span></md-table-cell>
						<md-table-cell>
							<div>
								<p v-for="driver in location.driver_pickup_list" style="margin: 0">
									<span>{{driver.name}}</span>
									<span style="cursor: pointer;"
										@click="removeDriverLocation(driver.id, location.id, 'pickup');">
										<md-icon class="md-danger">remove</md-icon>
										<md-tooltip md-direction="top">លុបចេញពីតំបន់នេះ</md-tooltip>
									</span>
									<br>
								</p>
							</div>
						</md-table-cell>
						<md-table-cell>
							<div>
								<p v-for="driver in location.driver_delivery_list" style="margin: 0">
									<span>{{driver.name}} 
										<span style="cursor: pointer;" @click="removeDriverLocation(driver.id, location.id, 'delivery');">
											<md-icon class="md-danger">remove</md-icon>
											<md-tooltip md-direction="top">លុបចេញពីតំបន់នេះ</md-tooltip>
										</span>
									</span>
									<br>
								</p>
							</div>	
						</md-table-cell>
					</md-table-row>
				</template>
			</md-table>
		</div>

		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានអំពីតំបន់</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* តម្រូវឱ្យបំពេញ</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>ឈ្មោះតំបន់ដឹកជញ្ជូន *</label>
								<md-input type="text" v-model="zone.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-50 md-size-70">
							<md-field>
								<label>បញ្ចូលទីតាំងក្នុងតំបន់ *</label>
								<md-input type="text" v-model="zone.location" @keyup.enter="addLocation()"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-50 md-size-30">
							<md-button class="md-raised md-primary" @click="addLocation()"
								style="width: 100%">ដាក់បញ្ចូល
							</md-button>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានសង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">ឈ្មោះតំបន់</md-table-cell>
								<md-table-cell style="width: 5px">៖</md-table-cell>
								<md-table-cell>
									<span v-if="String(zone.name).length > 0">{{zone.name}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>ទីតាំងក្នុងតំបន់នេះ</md-table-cell>
								<md-table-cell>៖</md-table-cell>
								<md-table-cell>
									<div v-if="zone.locationList.length > 0">
										<span v-for="(location, index) in zone.locationList"
											style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
											<span>{{location}}</span>
											<span style="cursor: pointer;" @click="removeLocation(index)">
												<md-icon class="md-danger">remove</md-icon>
												<md-tooltip md-direction="top">ដកចេញ</md-tooltip>
											</span>
										</span>
									</div>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="createZone()">បង្កើតតំបន់ថ្មី</md-button>
				</div>
			</div>
		</div>
		
		<div v-if="tabName == 'third'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានអំពីទីតាំងរបស់អ្នកទទួលឥវ៉ាន់</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* តម្រូវឱ្យបំពេញ</span>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>អ្នកទទួលឥវ៉ាន់ *</h3>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-70 md-size-70">
								<md-field>
									<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ ID</label>
									<md-input type="text" v-model="search_driver.text" @keyup.enter="searchDriver()">
									</md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-30 md-size-30">
								<md-button class="md-raised md-primary" @click="searchDriver()"
									style="width: 100%">ស្វែងរក</md-button>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<md-table>
									<md-table-row v-for="(driver, index) in search_driver.driverList">
										<md-table-cell>
											<img src="@/assets/img/default-driver.png"
												style="width: 34px; margin-right:5px">
											<b>ID: {{driver.hash_id}}</b> ({{driver.name}}, {{driver.phone}})
										</md-table-cell>
										<md-table-cell class="text-right">
											<md-button class="md-just-icon md-simple md-success"
												@click="addPickup(driver)">
												<md-icon>add</md-icon>
												<md-tooltip md-direction="top">ដាក់អ្នកទទួលឥវ៉ាន់</md-tooltip>
											</md-button>
										</md-table-cell>
									</md-table-row>
								</md-table>
							</div>
						</div>
					</div>

					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>តំបន់ *</label>
								<md-select placeholder="តំបន់ *" v-model="pickup.zone_id">
									<md-option :value="zone.id" v-for="zone in zoneList">{{zone.name}}</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-table>
								<md-table-row v-for="(location, index) in pickup.locationList">
									<md-table-cell style="width: 100%">{{location.name}}</md-table-cell>
									<md-table-cell class="text-right">
										<span style="cursor: pointer;"
											@click="selectPickupLocation(location)">
											<md-icon class="md-primary">add</md-icon>
											<md-tooltip md-direction="top">ដាក់អ្នកទទួលឥវ៉ាន់</md-tooltip>
										</span>
									</md-table-cell>
								</md-table-row>
							</md-table>
						</div>
					</div>

				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានសង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell>អ្នកទទួលឥវ៉ាន់</md-table-cell>
								<md-table-cell>៖</md-table-cell>
								<md-table-cell>
									<span v-if="String(pickup.driver_id).length > 0"
										style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
										<span><b>ID: {{pickup.driver_hash_id}} ({{pickup.driver_name}})</b></span>
										<md-button class="md-just-icon md-simple md-danger" @click="removePickup()">
											<md-icon>remove</md-icon>
											<md-tooltip md-direction="top">ដកចេញ</md-tooltip>
										</md-button>
									</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell style="width: 50%;">ឈ្មោះទីតាំង</md-table-cell>
								<md-table-cell style="width: 5px">៖</md-table-cell>
								<md-table-cell>
									<div v-if="pickup.location_selected_list.length > 0">
										<span v-for="(location, index) in pickup.location_selected_list"
											style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
											<span>{{location.name}}</span>
											<span style="cursor: pointer;" @click="removePickupLocation(index)">
												<md-icon class="md-danger">remove</md-icon>
												<md-tooltip md-direction="top">ដកចេញ</md-tooltip>
											</span>
										</span>
									</div>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="createDriverPickup()">បញ្ចូល</md-button>
				</div>
			</div>
		</div>

		<div v-if="tabName == 'forth'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានអំពីទីតាំងរបស់អ្នកដឹកជញ្ជូន</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* តម្រូវឱ្យបំពេញ</span>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>អ្នកដឹកជញ្ជូន *</h3>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-70 md-size-70">
								<md-field>
									<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ ID</label>
									<md-input type="text" v-model="search_driver.text" @keyup.enter="searchDriver()">
									</md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-30 md-size-30">
								<md-button class="md-raised md-primary" @click="searchDriver()"
									style="width: 100%">ស្វែងរក</md-button>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<md-table>
									<md-table-row v-for="(driver, index) in search_driver.driverList">
										<md-table-cell>
											<img src="@/assets/img/default-driver.png"
												style="width: 34px; margin-right:5px">
											<b>ID: {{driver.hash_id}}</b> ({{driver.name}}, {{driver.phone}})
										</md-table-cell>
										<md-table-cell class="text-right">
											<md-button class="md-just-icon md-simple md-success"
												@click="addDriver(driver)">
												<md-icon>add</md-icon>
												<md-tooltip md-direction="top">ដាក់អ្នកដឹកជញ្ជូន</md-tooltip>
											</md-button>
										</md-table-cell>
									</md-table-row>
								</md-table>
							</div>
						</div>
					</div>

					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>តំបន់ *</label>
								<md-select placeholder="តំបន់ *" v-model="delivery.zone_id">
									<md-option :value="zone.id" v-for="zone in zoneList">{{zone.name}}</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-table>
								<md-table-row v-for="(location, index) in delivery.locationList">
									<md-table-cell style="width: 100%">{{location.name}}</md-table-cell>
									<md-table-cell class="text-right">
										<span style="cursor: pointer;"
											@click="selectDeliveryLocation(location)">
											<md-icon class="md-primary">add</md-icon>
											<md-tooltip md-direction="top">ដាក់អ្នកដឹកជញ្ជូន</md-tooltip>
										</span>
									</md-table-cell>
								</md-table-row>
							</md-table>
						</div>
					</div>

				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានសង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell>អ្នកដឹកជញ្ជូន</md-table-cell>
								<md-table-cell>៖</md-table-cell>
								<md-table-cell>
									<span v-if="String(delivery.driver_id).length > 0"
										style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
										<span><b>ID: {{delivery.driver_hash_id}} ({{delivery.driver_name}})</b></span>
										<md-button class="md-just-icon md-simple md-danger" @click="removeDriver()">
											<md-icon>remove</md-icon>
											<md-tooltip md-direction="top">ដកចេញ</md-tooltip>
										</md-button>
									</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell style="width: 50%;">ឈ្មោះទីតាំង</md-table-cell>
								<md-table-cell style="width: 5px">៖</md-table-cell>
								<md-table-cell>
									<div v-if="delivery.location_selected_list.length > 0">
										<span v-for="(location, index) in delivery.location_selected_list"
											style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
											<span>{{location.name}}</span>
											<span style="cursor: pointer;" @click="removeDeliveryLocation(index)">
												<md-icon class="md-danger">remove</md-icon>
												<md-tooltip md-direction="top">ដកចេញ</md-tooltip>
											</span>
										</span>
									</div>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="createDriverDelivery()">បញ្ចូល</md-button>
				</div>
			</div>
		</div>
	</div>

</template>

<script>

	export default {

		created() {
			this.getZone();
		},
		data() {
			return {
				tabName: 'first',
				tagList: [],
				zone: {
					name: "",
					location: "",
					locationList: []
				},
				search_driver: {
					text: "",
					driverList: [],
				},
				delivery: {
					driver_id: "",
					driver_name: "",
					driver_hash_id: "",
					zone_id: "",
					location_selected_list: [],
					locationList: []
				},
				pickup: {
					driver_id: "",
					driver_name: "",
					driver_hash_id: "",
					zone_id: "",
					location_selected_list: [],
					locationList: []
				},
				zoneList: [],
				newLocationList: []
			}
		},
		watch: {
			"delivery.zone_id": function () {
				for (let i = 0; i < this.zoneList.length; i++) {
					if (this.delivery.zone_id != "" && this.delivery.zone_id == this.zoneList[i].id) this.delivery.locationList = this.zoneList[i].location_list;
					this.filterList();
				}
			},
			"delivery.location_selected_list": function () {
				this.filterList();
			},
			"pickup.zone_id": function () {
				for (let i = 0; i < this.zoneList.length; i++) {
					if (this.pickup.zone_id != "" && this.pickup.zone_id == this.zoneList[i].id) this.pickup.locationList = this.zoneList[i].location_list;
					this.filterList();
				}
			},
			"pickup.location_selected_list": function () {
				this.filterList();
			}
		},
		computed: {
			getDeliveryZoneName() {
				if (String(this.delivery.zone_id).length > 0) {
					for (let i = 0; i < this.zoneList.length; i++) {
						if (this.delivery.zone_id == this.zoneList[i].id) {
							return this.zoneList[i].name;
						}
					}
				} else {
					return "មានបញ្ហា"
				}
			},
			getPickupZoneName() {
				if (String(this.pickup.zone_id).length > 0) {
					for (let i = 0; i < this.zoneList.length; i++) {
						if (this.pickup.zone_id == this.zoneList[i].id) {
							return this.zoneList[i].name;
						}
					}
				} else {
					return "មានបញ្ហា"
				}
			}
		},
		methods: {
			filterList() {
				for (let i = 0; i < this.delivery.location_selected_list.length; i++) {
					for (let j = 0; j < this.delivery.locationList.length; j++) {
						if (this.delivery.location_selected_list[i].id == this.delivery.locationList[j].id) {
							this.delivery.locationList.splice(j, 1);
						}
					}
				}

				for (let i = 0; i < this.pickup.location_selected_list.length; i++) {
					for (let j = 0; j < this.pickup.locationList.length; j++) {
						if (this.pickup.location_selected_list[i].id == this.pickup.locationList[j].id) {
							this.pickup.locationList.splice(j, 1);
						}
					}
				}
			},
			getZone() {
				this.$http.get(this.config.api + "/admin/zone/get/list").then(data => {
					this.zoneList = data.body.data
					for (let i = 0; i < this.zoneList.length; i++) {
						this.newLocationList.push({ new_location: "" });
					}
				})
			},
			searchDriver() {
				this.$http.post(this.config.api + "/admin/driver/search", {
					text: this.search_driver.text,
					status: "",
					offset: 0
				}).then(data => {
					this.search_driver.text = "";
					this.search_driver.driverList = data.body.data;
					this.$forceUpdate();
				})
			},
			createZone() {
				if (this.checkValidationZone()) {
					this.$http.post(this.config.api + "/admin/zone/post", {
						zone: this.zone
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "តំបន់ត្រូវបានបង្កើតឡើងដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.getZone();
							this.zone = { name: "", locationList: [] }
							this.tabName = 'first';

							// this.getSettings();

						}
					})
				}
			},
			checkValidationZone() {
				if (String(this.zone.name).length > 3 && this.zone.locationList.length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "ព័ត៌មានមិនគ្រប់គ្រាន់ សូមពិនិត្យមើលម្តងទៀត។",
						icon: 'error',
						type: 'danger'
					})
					return false;
				}
			},
			createDriverDelivery() {
				if (this.checkValidationDriver("delivery")) {
					this.$http.post(this.config.api + "/admin/zone/post_driver_delivery", {
						location_list: this.delivery.location_selected_list,
						driver_id: this.delivery.driver_id,
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({message: "អ្នកដឹកជញ្ជូនត្រូវបានដាក់ចូលតំបន់ដោយជោគជ័យ។", icon: 'done', type: 'success' })
							this.tabName = 'first';
							this.delivery = { zone_id: "", driver_id: "", location_selected_list: [], locationList: [] }
							this.getZone();
						}
					})
				}
			},
			createDriverPickup() {
				if (this.checkValidationDriver("pickup")) {
					this.$http.post(this.config.api + "/admin/zone/post_driver_pickup", {
						location_list: this.pickup.location_selected_list,
						driver_id: this.pickup.driver_id,
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({message: "អ្នកដឹកជញ្ជូនត្រូវបានដាក់ចូលតំបន់ដោយជោគជ័យ។", icon: 'done', type: 'success' })
							this.tabName = 'first';
							this.pickup = { zone_id: "", driver_id: "", location_selected_list: [], locationList: [] }
							this.getZone();
						}
					})
				}
			},
			checkValidationDriver(type) {

				if (type == "delivery" && this.delivery.location_selected_list.length > 0 && String(this.delivery.driver_id).length > 0) {
					return true;
				} else if (type == "pickup" && this.pickup.location_selected_list.length > 0 && String(this.pickup.driver_id).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "ព័ត៌មានមិនគ្រប់គ្រាន់ សូមពិនិត្យមើលម្តងទៀត។",
						icon: 'error',
						type: 'danger'
					})
					return false;
				}

			},
			removeDriverLocation(driver_id, location_id, type = "delivery") {
				this.$http.post(this.config.api + "/admin/zone/delete_driver", {
					location_id: location_id,
					driver_id: driver_id,
					type: type
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "អ្នកដឹកជញ្ជូនត្រូវបានដកចេញពីទីតាំងដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.tabName = 'first';
						this.getZone();
					}
				})
			},
			newLocation(zone_id, index) {
				let name = this.newLocationList[index].new_location;
				if (String(name).length > 1) {
					this.$http.post(this.config.api + "/admin/zone/new_location", {
						zone_id: zone_id,
						name: name
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "ទីតាំងត្រូវបានបង្កើតដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.newLocationList[index].new_location = "";
							this.tabName = 'first';
							this.getZone();
						}
					})
				}

			},
			addLocation() {
				if (String(this.zone.location).length > 0) {
					this.zone.locationList.push(this.zone.location);
					this.zone.location = "";
				}
			},
			addDriver(driver) {
				this.delivery.driver_id = driver.id;
				this.delivery.driver_name = driver.name;
				this.delivery.driver_hash_id = driver.hash_id;
				this.search_driver.driverList = [];
			},
			removeDriver() {
				this.delivery.driver_id = "";
				this.delivery.driver_name = "";
				this.delivery.driver_hash_id = "";
			},
			addPickup(driver) {
				this.pickup.driver_id = driver.id;
				this.pickup.driver_name = driver.name;
				this.pickup.driver_hash_id = driver.hash_id;
				this.search_driver.driverList = [];
			},
			removePickup() {
				this.pickup.driver_id = "";
				this.pickup.driver_name = "";
				this.pickup.driver_hash_id = "";
			},
			removeLocation(index) {
				this.zone.locationList.splice(index, 1);
			},
			selectDeliveryLocation(location) {
				let exist = false;
				for(let i = 0; i < this.delivery.location_selected_list.length; i++){
					if(this.delivery.location_selected_list[i].id == location.id) exist = true;
				}
				if(!exist) this.delivery.location_selected_list.push({id: location.id, name: location.name});
				this.filterList();
			},
			removeDeliveryLocation(index){
				this.pickup.location_selected_list.splice(index, 1);
			},
			selectPickupLocation(location) {
				let exist = false;
				for(let i = 0; i < this.pickup.location_selected_list.length; i++){
					if(this.pickup.location_selected_list[i].id == location.id) exist = true;
				}
				if(!exist) this.pickup.location_selected_list.push({id: location.id, name: location.name});
				this.filterList();
			},
			removePickupLocation(index){
				this.pickup.location_selected_list.splice(index, 1);
			}
		}
	}
</script>

<style scoped>
	.grid-8 {
		text-align: center;
		max-width: 12.5%;
		min-width: 12.5%;
		flex: 0 0 12.5%;
	}

	.thumb-product {
		width: 100%;
	}

	.product-thumbnail {
		width: 100px;
		height: 100px;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Zones/View.vue